module.exports = __webpack_public_path__ + "static/media/SEARCH.885bf42b.svg";